const projectRoot = 'static/examples/domi-car';

const domiCarExamples = [{
    id: 'controller-driving',
    projectPath: `${projectRoot}/controller-driving.sb3`,
    title: {
        id: 'gui.domiExamples.controllerDriving.title',
        defaultMessage: 'Bluetooth controller driving'
    },
    description: {
        id: 'gui.domiExamples.controllerDriving.description',
        defaultMessage: 'Program the controller arrows, OK and A-F buttons, preview them on the page, ' +
            'then write the project to the car.'
    },
    preview: 'controller',
    mode: 'offline',
    assetVersion: 'controller-functions-layout-v4',
    extensionIds: ['domiCar', 'domiController'],
    actions: [{
        id: 'gui.domiExamples.action.controllerDirections',
        defaultMessage: 'Hold arrows = move; release = stop'
    }, {
        id: 'gui.domiExamples.action.controllerLights',
        defaultMessage: 'OK = toggle light'
    }, {
        id: 'gui.domiExamples.action.controllerFunctionLights',
        defaultMessage: 'A/B = light on/off'
    }, {
        id: 'gui.domiExamples.action.controllerFunctionMoves',
        defaultMessage: 'C/D/E/F = short moves'
    }, {
        id: 'gui.domiExamples.action.controllerBurn',
        defaultMessage: 'Write from Burn Center'
    }]
}, {
    id: 'keyboard-control',
    projectPath: `${projectRoot}/keyboard-control.sb3`,
    title: {
        id: 'gui.domiExamples.keyboard.title',
        defaultMessage: 'Keyboard remote control'
    },
    description: {
        id: 'gui.domiExamples.keyboard.description',
        defaultMessage: 'Hold an arrow key to move and release it to stop. Press space to stop immediately.'
    },
    preview: 'keyboard',
    mode: 'online',
    actions: [{
        id: 'gui.domiExamples.action.arrowKeys',
        defaultMessage: 'Hold arrow keys = move; release = stop'
    }, {
        id: 'gui.domiExamples.action.spaceStop',
        defaultMessage: 'Space = stop immediately'
    }]
}, {
    id: 'forward-and-stop',
    projectPath: `${projectRoot}/forward-and-stop.sb3`,
    title: {
        id: 'gui.domiExamples.forward.title',
        defaultMessage: 'Move forward for one second'
    },
    description: {
        id: 'gui.domiExamples.forward.description',
        defaultMessage: 'Click the green flag to move forward for one second and stop.'
    },
    preview: 'forward',
    mode: 'online',
    actions: [{
        id: 'gui.domiExamples.action.greenFlag',
        defaultMessage: 'Green flag'
    }, {
        id: 'gui.domiExamples.action.forwardOneSecond',
        defaultMessage: 'Forward 1 s'
    }, {
        id: 'gui.domiExamples.action.stop',
        defaultMessage: 'Stop'
    }]
}, {
    id: 'light-show',
    projectPath: `${projectRoot}/light-show.sb3`,
    title: {
        id: 'gui.domiExamples.light.title',
        defaultMessage: 'Car light show'
    },
    description: {
        id: 'gui.domiExamples.light.description',
        defaultMessage: 'Turn the car light on for one second, then turn it off.'
    },
    preview: 'light',
    mode: 'online',
    actions: [{
        id: 'gui.domiExamples.action.lightOn',
        defaultMessage: 'Light on'
    }, {
        id: 'gui.domiExamples.action.waitOneSecond',
        defaultMessage: 'Wait 1 s'
    }, {
        id: 'gui.domiExamples.action.lightOff',
        defaultMessage: 'Light off'
    }]
}, {
    id: 'camera-view',
    projectPath: `${projectRoot}/camera-view.sb3`,
    title: {
        id: 'gui.domiExamples.camera.title',
        defaultMessage: 'Camera viewer'
    },
    description: {
        id: 'gui.domiExamples.camera.description',
        defaultMessage: 'Open the car camera with the green flag and close it with space.'
    },
    preview: 'camera',
    mode: 'online',
    actions: [{
        id: 'gui.domiExamples.action.greenFlagCamera',
        defaultMessage: 'Green flag = open camera'
    }, {
        id: 'gui.domiExamples.action.spaceCamera',
        defaultMessage: 'Space = close camera'
    }]
}, {
    id: 'patrol-route',
    projectPath: `${projectRoot}/patrol-route.sb3`,
    title: {
        id: 'gui.domiExamples.patrol.title',
        defaultMessage: 'Square patrol route'
    },
    description: {
        id: 'gui.domiExamples.patrol.description',
        defaultMessage: 'Repeat forward and right turns to drive a square route.'
    },
    preview: 'route',
    mode: 'online',
    actions: [{
        id: 'gui.domiExamples.action.repeatFour',
        defaultMessage: 'Repeat 4 times'
    }, {
        id: 'gui.domiExamples.action.forwardOneSecond',
        defaultMessage: 'Forward 1 s'
    }, {
        id: 'gui.domiExamples.action.turnRight',
        defaultMessage: 'Turn right 0.45 s'
    }]
}, {
    id: 'patrol-mission',
    projectPath: `${projectRoot}/patrol-mission.sb3`,
    title: {
        id: 'gui.domiExamples.mission.title',
        defaultMessage: 'Integrated patrol mission'
    },
    description: {
        id: 'gui.domiExamples.mission.description',
        defaultMessage: 'Use nested loops to patrol two laps with the camera, lights and a finish sequence.'
    },
    preview: 'mission',
    mode: 'online',
    actions: [{
        id: 'gui.domiExamples.action.openCameraAndLight',
        defaultMessage: 'Open camera and light'
    }, {
        id: 'gui.domiExamples.action.repeatTwoLaps',
        defaultMessage: 'Repeat 2 laps'
    }, {
        id: 'gui.domiExamples.action.repeatFourSides',
        defaultMessage: 'Repeat 4 sides per lap'
    }, {
        id: 'gui.domiExamples.action.lapLightSignal',
        defaultMessage: 'Blink after each lap'
    }, {
        id: 'gui.domiExamples.action.finishMission',
        defaultMessage: 'Stop and close camera'
    }]
}, {
    id: 'driving-challenge',
    projectPath: `${projectRoot}/driving-challenge.sb3`,
    title: {
        id: 'gui.domiExamples.challenge.title',
        defaultMessage: 'Advanced driving challenge'
    },
    description: {
        id: 'gui.domiExamples.challenge.description',
        defaultMessage: 'Switch the arrow keys between step and hold-to-drive modes. Forward and backward use three ' +
            'movement ranges, while turns use a fixed 0.3 seconds, alongside reusable custom blocks, camera and ' +
            'light shortcuts and a two-lap automatic patrol.'
    },
    preview: 'challenge',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.action.challengeDrive',
        defaultMessage: 'Arrow keys use the selected step or hold-to-drive mode'
    }, {
        id: 'gui.domiExamples.action.challengeGears',
        defaultMessage: '1 / 2 / 3 = three forward and backward movement ranges'
    }, {
        id: 'gui.domiExamples.action.challengeModes',
        defaultMessage: '4 = step mode; 5 = hold-to-drive mode'
    }, {
        id: 'gui.domiExamples.action.challengeCameraLight',
        defaultMessage: 'C / X and L / O = camera and lights'
    }, {
        id: 'gui.domiExamples.action.challengePatrol',
        defaultMessage: 'P = two-lap automatic patrol'
    }, {
        id: 'gui.domiExamples.action.challengeEmergency',
        defaultMessage: 'Space = emergency stop'
    }, {
        id: 'gui.domiExamples.action.challengeVariables',
        defaultMessage: 'Track gear, state and action count with variables'
    }]
}, {
    id: 'offline-square-route',
    projectPath: `${projectRoot}/offline-square-route.sb3`,
    title: {
        id: 'gui.domiExamples.offline.title',
        defaultMessage: 'Offline square route'
    },
    description: {
        id: 'gui.domiExamples.offline.description',
        defaultMessage: 'A power-on route that can be written to the car from Burn Center.'
    },
    preview: 'offline',
    mode: 'offline',
    actions: [{
        id: 'gui.domiExamples.action.powerOn',
        defaultMessage: 'When the car powers on'
    }, {
        id: 'gui.domiExamples.action.squareRoute',
        defaultMessage: 'Repeat the square route'
    }, {
        id: 'gui.domiExamples.action.burnCenter',
        defaultMessage: 'Write from Burn Center'
    }]
}];

export default domiCarExamples;
